import React from "react";
import { InfoIcon } from "./Svg";
import Text from "./Text";

const TitleBanner = ({ title, color, showInfoIcon = true, style = {} }) => (
  <div
    className="flex items-center h-full px-4 py-4 relative bg-critical outline-none justify-between w-full border-0 rounded-sm"
    style={{ outline: 0, backgroundColor: color, ...style }}
  >
    <div className="flex items-center">
      {showInfoIcon && <InfoIcon color="white" className="mr-1" />}
      <Text className="inline pr-2 text-white">{title}</Text>
    </div>
  </div>
);

export default TitleBanner;
